export const UserPermission = {
    Dashboard: {
        Read: "Dashboard.Read"
    },
    User: {
        Read: "User.Read",
        Write: "User.Write",
        Delete: "User.Delete"
    },
    Roles: {
        Read: "Roles.Read",
        Write: "Roles.Write",
        Delete: "Roles.Delete"
    },
    Departments: {
        Read: 'Departments.Read',
        Write: 'Departments.Write',
        Delete: 'Departments.Delete',
    },
    Locations: {
        Read: 'Locations.Read',
        Write: 'Locations.Write',
        Delete: 'Locations.Delete',
    },
    Wip: {
        Read: 'Wip.Read',
        Write: 'Wip.Write',
        Delete: 'Wip.Delete'
    },
    Transaction: {
        Read: 'Transaction.Read',
        Write: 'Transaction.Write',
        Delete: 'Transaction.Delete'
    },
    ProductionReport: {
        Read: 'ProductionReport.Read',
        Write: 'ProductionReport.Write',
        Delete: 'ProductionReport.Delete'
    },
    SNMCC: {
        Read: 'SNMCC.Read',
        Write: 'SNMCC.Write',
        Delete: 'SNMCC.Delete'
    },
    BagList: {
        Read: 'Bag.Read',
        Write: 'Bag.Write',
        Delete: 'Bag.Delete'
    }

};
